// extracted by mini-css-extract-plugin
module.exports = {"SectionI":"SectionI_SectionI__SWgy5"};